module.exports = __webpack_public_path__ + "img/M007-11_jrb-03.ad5fff4f.jpg";